import axios from "axios";

class MarketingService {
  static async uploadARD(formData) {
    try {
      const result = await axios.post("/marketing/uploadARD", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        responseType: "blob",
      });
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async getCampana() {
    try {
      const result = await axios.get("/marketing/campanaMailsResumenes", {
        responseType: "blob",
      });
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async uploadCruce(formData) {
    try {
      const result = await axios.post("/marketing/uploadCruce", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        responseType: "blob",
      });
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async estadoTarjetas(formData) {
    try {
      const result = await axios.post("/marketing/estadoTarjetas", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        responseType: "blob",
      });
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async pagosQr(dates) {
    try {
      const result = await axios.post("/marketing/pagosQr", dates, {
        responseType: "blob",
      });
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  //todo el stock
  static async getTmcStock() {
    try {
      const result = await axios.get("/marketing/tmcStock");
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async getStockMovements(stockId, commerceId = null) {
    try {
      const result = await axios.get(`/marketing/tmcStock/${stockId}/movements`, {
        params: commerceId ? { commerceId } : {},
      });
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async getStockMovementsReport(filters = {}) {
    try {
      const result = await axios.post("/marketing/tmcStockMovements/report", filters);
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async validateTmcCoupon(code) {
    try {
      const result = await axios.get(`/tmcCoupons/validate/${encodeURIComponent(code)}`);
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  //Traemos los proveedores
  static async getProvider() {
    try {
      const result = await axios.get("/marketing/provider");
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  // Traemos los depositos origen
  static async getDeposit() {
    try {
      const result = await axios.get("/marketing/deposit");
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async createDeposit(payload) {
    try {
      const result = await axios.post("/marketing/deposit", payload);
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async updateDeposit(id, payload) {
    try {
      const result = await axios.put(`/marketing/deposit/${id}`, payload);
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async deleteDeposit(id) {
    try {
      const result = await axios.delete(`/marketing/deposit/${id}`);
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  //cargar archivo
  static async uploadStockFile(formData) {
    try {
      const result = await axios.post("/marketing/uploadStock", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return result.data;
    } catch (error) {
      console.error("Error en uploadStockFile:", error);
      return Promise.reject(error);
    }
  }

  static async createBankaLimitRequest(formValues) {
    try {
      const result = await axios.post("/marketing/banka/limit-requests", formValues);
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async getBankaLimitRequests(filters = {}) {
    try {
      const result = await axios.get("/marketing/banka/limit-requests", {
        params: filters,
      });
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async approveBankaLimitRequest(id, payload) {
    try {
      const result = await axios.post(
        `/marketing/banka/limit-requests/${id}/approve`,
        payload
      );
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async updateBankaLimitRequest(id, payload) {
    try {
      const result = await axios.patch(
        `/marketing/banka/limit-requests/${id}`,
        payload
      );
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async rejectBankaLimitRequest(id, payload) {
    try {
      const result = await axios.post(
        `/marketing/banka/limit-requests/${id}/reject`,
        payload
      );
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  // borramos tmcstock por proveedor
  static async deleteTmcStock(idProvider, commerceId) {
    try {
      const result = await axios.delete(
        `marketing/deleteTmcStock/${idProvider}`,
        { params: { commerceId } }
      );
      return result.data;
    } catch (error) {
      console.error("Error en Eliminar TmcStock:", error);
      return Promise.reject(error);
    }
  }

  //Pasamos el dni al back para que traiga las tarjetas por api
  static async getCards(dni) {
    try {
      const result = await axios.get(`marketing/getCards/${dni}`);
      return result.data;
    } catch (error) {
      console.error("Error al intentar encontrar las tarjetas:", error);
      return Promise.reject(error);
    }
  }

  //stock desde la base
  static async getStockSelected(code, commerceId = null) {
    try {
      const result = await axios.get(`marketing/getStockSelected/${code}`, {
        params: commerceId ? { commerceId } : {},
      });
      return result.data;
    } catch (error) {
      console.error("Error al intentar encontrar las stock:", error);
      return Promise.reject(error);
    }
  }
  //traemos provincias
  static async getProvince() {
    try {
      const result = await axios.get(`marketing/getProvince`);
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  //guardamos la venta
  static async onSubmitBanka(formValues) {
    try {
      const {data} = await axios
        .post(`marketing/onSubmitBanka`, formValues)
        .then((res) => res.data);
      return data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
  //guardamos stock
  static async onSubmitStock(formValues) {
    try {
      const result = await axios
        .post(`marketing/onSubmitStock`, formValues)
        .then((res) => res.data);
      return result;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async anularVenta(saleId) {
    const result = await axios.post(`marketing/anularVenta`, { saleId });
    return result.data;
  }

  static async generarComprobante(saleId) {
    const result = await axios.get(`marketing/generarComprobante/${saleId}`, {
      responseType: "text",
    });
    return result.data; // HTML string
  }

  static async downloadSaleReceipt(saleId) {
    const result = await axios.get(`marketing/saleReceipt/${saleId}/download`, {
      responseType: "blob",
    });
    return result.data;
  }

  static async emailSaleReceipt(saleId, email) {
    const result = await axios.post(`marketing/saleReceipt/${saleId}/email`, {
      email,
    });
    return result.data;
  }

  //actualizamos stock
  static async addStockToDeposit(formValues) {
    try {
      const result = await axios.post(
        `marketing/addStockToDeposit`,
        formValues
      );
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async setStockInDeposit(formValues) {
    try {
      const result = await axios.post(
        `marketing/setStockInDeposit`,
        formValues
      );
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async moveStock(formValues) {
    try {
      const result = await axios.post(`marketing/moveStock`, formValues);
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async getStockTransfers(filters = {}) {
    try {
      const result = await axios.get("marketing/tmcStockTransfers", {
        params: filters,
      });
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async acceptStockTransfer(id, payload) {
    try {
      const result = await axios.post(
        `marketing/tmcStockTransfers/${id}/accept`,
        payload
      );
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async exitCodeStock(code, commerceId) {
    try {
      const result = await axios.get(
        `marketing/exitCodeStock/${encodeURIComponent(code)}`,
        { params: { commerceId } }
      );
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async saveNewProduct(formValues) {
    try {
      const result = await axios.post(`marketing/saveNewProduct`, formValues);
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }

  static async updateProduct(id, formValues) {
    try {
      const result = await axios.put(`marketing/products/${id}`, formValues);
      return result.data;
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
export default MarketingService;
